/**
 * Google Ads conversion tracking config.
 * ======================================
 * The Google Ads tag (AW-18392223900) is loaded globally in public/index.html.
 *
 * Each conversion ACTION you create in Google Ads
 * (Goals → Conversions → New conversion action → Website) has its own
 * "conversion label". Open the action → "Use Google tag" and copy the label
 * (the part AFTER the slash in send_to: 'AW-18392223900/XXXXXXXX') into the
 * matching entry below.
 *
 * Until a label is filled in, the helper still fires an account-level
 * conversion + a dataLayer event, so the tag receives the hit — but Google
 * Ads only *counts* it against a conversion action once the label is set.
 *
 * Conversion actions used by Corvana:
 *   • enquiry         — any enquiry / contact button submission
 *   • waitlist_signup — "Join the Waitlist" registrations
 *   • demo_booking    — "Book a Demo" (calendar booking) completions
 */
export const ADS_CONVERSION_ID = 'AW-18392223900';

export const ADS_CONVERSIONS = {
  enquiry:         { name: 'Enquiry',           label: 'JgzICOLbzeQcEJyhjMJE' },
  waitlist_signup: { name: 'Waitlist Signup',   label: '6wyGCPXuzeQcEJyhjMJE' },
  demo_booking:    { name: 'Demo Booking',      label: 'CbBhCPfbzeQcEJyhjMJE' },
  register:        { name: 'Full Registration', label: 'v8dECODVwuQcEJyhjMJE' },
};
